@if (isLegacy) {
    <div class="casino-game-tile-desc-container">
        <div class="container-icon">
            @if (iconClass) {
                <!-- We need icon component here -->
                <div id="cs-icon" class="cs-icon" [ngClass]="iconClass"></div>
            }
        </div>

        <div class="container-desc-text">
            @if (titleText) {
                <div id="cs-title-text" class="title-uk" [style]="titleInlineStyle">{{ titleText }}</div>
            }

            @if (subtitleText) {
                <div id="cs-subtitle-text" class="subtitle-uk" [class]="subtitleClass" [style]="subtitleInlineStyle">
                    {{ subtitleText }}
                </div>
            }
        </div>
    </div>
}
